"use strict";

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _ravenJs = require("raven-js");

var _ravenJs2 = _interopRequireDefault(_ravenJs);

var _localStorage = require("./localStorage");

var _localStorage2 = _interopRequireDefault(_localStorage);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var tags = {};
window._nounConfig = window._nounConfig || {};
if (window._nounConfig.pluginHost) {
    tags = { pluginHost: window._nounConfig.pluginHost };
}

var sentryConfig = {
    debug: window._nounConfig.debugMode,
    environment: window._nounConfig.environment,
    tags: tags,
    release: window._nounConfig.release,
    ignoreErrors: ["Cannot read property 'undefined' of undefined", "AMCore is not defined"],
    maxMessageLength: 1000,
    whitelistUrls: [/static\.(test|staging|production)?\.?thenounproject\.com\/assets\/bundles\/main-[a-z0-9]*.js/],
    shouldSendCallback: function shouldSendCallback(data) {
        // Log errors for the dev environment, but don't send to Sentry
        if (window._nounConfig.environment === "dev") {

            return false;
        }
        var ieString = void 0;
        var ref = void 0;
        ieString = navigator.userAgent.match(/MSIE \d+.0/);
        if (ieString && ((ref = ieString[0]) === "MSIE 7.0" || ref === "MSIE 8.0" || ref === "MSIE 9.0")) {
            return false;
        }
        return true;
    }
};

// Let exceptions from webpack files through to Sentry handling code in development
// but stop them from actually being sent in shouldSendCallback
if (process.env.NODE_ENV != "production") {
    sentryConfig.whitelistUrls.push(/webpack/);
}

var Sentry = _ravenJs2.default.config(window._nounConfig.sentryDSN, sentryConfig);

var sentryDisabled = _localStorage2.default.getItem("DISABLE_JS_SENTRY");

if (!sentryDisabled) {
    Sentry.install();
} else {
    console.warn("Sentry disabled.");
}

// Check error sending to Sentry
window._errorCheck = function () {
    Sentry.captureException(new Error("It worked!"));
    return true;
};

exports.default = Sentry;